
//export  const url = 'https://api.distribution.ink-it.ink/api/clube/';
//export  const urlDistribution = 'https://api.distribution.ink-it.ink/api/distribution/';
//export  const urlConversion = 'https://api.distribution.ink-it.ink/api/conversion/';
//export  const url = 'http://localhost:5000/api/clube/';
//export  const urlConversion = 'http://localhost:5000/api/conversion/';
//export  const urlDistribution = 'http://localhost:5000/api/distribution/';

export const url = process.env.REACT_APP_CLUBE_API_URL;
export const urlDistribution = process.env.REACT_APP_DISTRIBUTION_API_URL;

/**
 * La API del modulo Newsletter vive en el mismo host que distribution
 * (/api/newsletter/). Se deriva de REACT_APP_DISTRIBUTION_API_URL cuando falta
 * la variable propia, para que un build sin REACT_APP_NEWSLETTER_API_URL no
 * genere URLs relativas tipo "undefinedconfig" (nginx las responde con el
 * index.html del SPA y el modulo parece roto por un error de conexion).
 *
 * Se normaliza con una funcion porque al compilar CRA sustituye
 * `process.env.REACT_APP_NEWSLETTER_API_URL` por el objeto process.env completo
 * cuando la variable no existe en el build: no es undefined, es un objeto
 * (truthy), asi que un `||` no detectaria que falta.
 */
const normalizeUrl = (value) => typeof value === 'string' && value.indexOf('://') !== -1 ? value : '';

export const urlNewsletter = normalizeUrl(process.env.REACT_APP_NEWSLETTER_API_URL)
    || (normalizeUrl(process.env.REACT_APP_DISTRIBUTION_API_URL) || '').replace(/distribution\/?$/, 'newsletter/');
export const urlConversion = process.env.REACT_APP_CONVERSION_API_URL;
export const urlInk = process.env.REACT_APP_INK_API_URL;
export const urlDelivery = process.env.REACT_APP_DELIVERY_API_URL;
export const urlTasks = process.env.REACT_APP_TASKS_API_URL;
export const urlPod = process.env.REACT_APP_POD_API_URL;

export const endpointDataByOnix = 'data_by_onix';
export const endpointValidateEpub = 'validate_epub';
export const endpointDownloadInvalidEpub = 'dowload_invalid_epubs';
export const endpointDownloadBrokenLinks = 'download_broken_links';
export const endpointSendInkit = 'send_metadata_to_ink';
export const endpointUploadAssets = 'upload_assets';
export const endpointNotify = 'send_status_ebook_inkit';
export const endpointLogin = 'login';
export const endpointOnixList = 'onix_list';
export const endpointSetNotifications = 'set_notifications';
export const endpointLastOnix = 'new_onix';
export const endpointChannels = 'get_channels_delivery';
export const endpointGetChannelsDelivery = 'get_channels_delivery';
export const endpointGetStock = 'get_stock';
export const endpointDownloadCSVStock = 'download_csv_stock';
export const endpointDownloadXlsxStock = 'download_xlsx_stock';
export const endpointGetConversions = 'get_all';
export const endpointUploadConversion = 'upload_conversion';
export const endpointGetAccounts = 'api/services/accounts/get_accounts_admin.php';
export const endpointUploadXlsx = 'upload_xlsx';
export const endpointCompleteISBN = 'complete_isbn';
export const endpointUploadAdminCover = 'upload_admin_cover';
export const endpointAdminRemoveConversion = 'admin_remove';
export const endpointDownloadIsbnTemplate = 'download_isbn_template';
export const endpointUploadIsbnTemplate = 'upload_isbn_template';

export const endpointDownloadZip = 'download_zip';
export const endpointSetDoneNotifications = 'set_done_notifications_delivery';
export const endpointDeleteNotifications = 'delete_notifications_delivery';
export const endpointGeneratePackage = 'generate_package';

// Reports endpoints (tasks API)
export const endpointGetStoreReports = 'get_store_reports';
export const endpointUploadReportFile = 'upload_report_file';  // Mantener para sincronización directa
export const endpointStoreReportData = 'store_report_data';  // Antiguo: guardar en BD
export const endpointSyncReportsToInkit = 'sync_reports_to_inkit';  // Antiguo: sincronizar con Inkit
export const endpointGetChannelsWithReports = 'get_channels_with_reports';
export const endpointGetStockStatusReport = 'stock_status_report';

// Optimized Reports endpoints
//export const endpointUploadReportOptimized = 'upload_status_channel_optimized';
export const endpointUploadReportOptimized = 'upload_report_optimized';  // Nuevo: carga optimizada
export const endpointSyncReportsOptimized = 'sync_reports_optimized';  // Nuevo: sincronización optimizada
export const endpointGetStatusComparisonReport = 'status_comparison_report'; // Nuevo: reporte comparativo
export const endpointSyncReportsAll = 'sync_reports_all'; // Nuevo: sincronización total
export const endpointGetReportMetadataList = 'get_report_metadata_list'; // Historial de cargas por tienda
export const endpointGetNotActivatedReportItems = 'not_activated_report_items'; // Items no activados de un reporte
export const endpointGetInactiveTitles = 'get_inactive_titles'; // Títulos con status_channel='off' en una tienda
export const endpointGetInactiveTitlesV2 = 'get_inactive_titles_v2'; // V2 optimized search
export const endpointNotifyInactiveTitles = 'notify_inactive_titles'; // Notifica por correo los títulos con datos faltantes
export const endpointFillThemaFromBisac = 'fill_thema_from_bisac'; // Asigna categorías Thema desde BISAC en los títulos seleccionados

// Missing publication report (faltan publicar por canal)
export const endpointMissingPublication = 'missing_publication'; // Detalle paginado (JSON)
export const endpointMissingPublicationExport = 'missing_publication_export'; // Export XLSX
export const endpointMissingPublicationSummary = 'missing_publication_summary'; // Resumen por canal

// Ingram endpoints
export const endpointGetIngramTitles = 'api/pod/get_ingram_titles';
export const endpointUpdateIngramStatus = 'api/pod/update_ingram_status_admin';
export const endpointSendIngramRemovalNotice = 'api/pod/send_ingram_removal_notice';
export const endpointUploadIngramExcel = 'api/pod/upload_ingram_excel';
export const endpointDownloadIngramExcel = 'api/pod/download_ingram_excel';

// Financial endpoints
export const endpointGetExchangeRates = 'api/services/financial_reports/get_exchange_rates.php';
export const endpointSetExchangeRate = 'api/services/financial_reports/set_exchange_rate.php';
export const endpointDeleteExchangeRate = 'api/services/financial_reports/delete_exchange_rate.php';

// Accounts & Users module (Cuentas y Usuarios)
export const endpointAdminListAccounts = 'api/services/accounts/admin_list_accounts.php';
export const endpointAdminSearchAccounts = 'api/services/accounts/admin_search_accounts.php';
export const endpointAdminGetAccount = 'api/services/accounts/admin_get_account.php';
export const endpointAdminValidatePrefix = 'api/services/accounts/admin_validate_prefix.php';
export const endpointAdminCreateAccount = 'api/services/accounts/admin_create_account.php';
export const endpointAdminUpdateAccount = 'api/services/accounts/admin_update_account.php';
export const endpointAdminDeactivateAccount = 'api/services/accounts/admin_deactivate_account.php';
export const endpointAdminDeleteAccount = 'api/services/accounts/admin_delete_account.php';
export const endpointAdminUpdateServices = 'api/services/accounts/admin_update_services.php';
export const endpointAdminExportAccounts = 'api/services/accounts/admin_export_accounts.php';
export const endpointAdminGetBilling = 'api/services/accounts/admin_get_billing.php';
export const endpointAdminSetBillingData = 'api/services/accounts/admin_set_billing_data.php';
export const endpointAdminSetBankInfo = 'api/services/accounts/admin_set_bank_info.php';

// Percent publishers (migrated from admin/percent_publishers)
export const endpointAdminGetChannels = 'api/services/accounts/percent_publishers/admin_get_channels.php';
export const endpointAdminGetPercentPublishers = 'api/services/accounts/percent_publishers/admin_get_percent_publishers.php';
export const endpointAdminSetPercentPublishers = 'api/services/accounts/percent_publishers/admin_set_percent_publishers.php';
export const endpointAdminDeletePercentPublishers = 'api/services/accounts/percent_publishers/admin_delete_percent_publishers.php';

export const endpointAdminListUsers = 'api/services/user/admin_list_users.php';
export const endpointAdminGetUser = 'api/services/user/admin_get_user.php';
export const endpointAdminCreateUser = 'api/services/user/admin_create_user.php';
export const endpointAdminUpdateUser = 'api/services/user/admin_update_user.php';
export const endpointAdminDeleteUser = 'api/services/user/admin_delete_user.php';
export const endpointAdminSetUserActive = 'api/services/user/admin_set_user_active.php';
export const endpointAdminAssignRole = 'api/services/user/admin_assign_role.php';
export const endpointAdminAssignAccount = 'api/services/user/admin_assign_account.php';
export const endpointAdminAssignPrimaryUser = 'api/services/user/admin_assign_primary_user.php';
export const endpointAdminNotifyUser = 'api/services/user/admin_notify_user.php';
export const endpointAdminValidateUser = 'api/services/user/admin_validate_user.php';
export const endpointAdminExportUsers = 'api/services/user/admin_export_users.php';

// Roles & permissions (matrices per role, granular catalog and self permissions)
export const endpointPermissionsCatalog = 'api/services/permissions_catalog.php';
export const endpointRolePresets = 'api/services/role_presets.php';
export const endpointGetMyPermissions = 'api/services/user/get_my_permissions.php';
export const endpointListAccountUsers = 'api/services/user/list_account_users.php';
export const endpointAssignAccountRole = 'api/services/user/assign_account_role.php';

// App root URL (used to open the app reports with the selected account session)
export const urlApp = process.env.REACT_APP_APP_INK_URL;

// Payments module (migrated from admin/payments_new)
export const endpointPaymentsGetMeta = 'api/services/payments/get_meta.php';
export const endpointPaymentsGetPayments = 'api/services/payments/get_payments.php';
export const endpointPaymentsGetUsdByChannel = 'api/services/payments/get_usd_by_channel.php';
export const endpointPaymentsPostPayments = 'api/services/payments/post_payments.php';
export const endpointPaymentsDownload = 'api/services/payments/download.php';
export const endpointPaymentsDownloadExcel = 'api/services/payments/download_excel.php';
export const endpointPaymentsGetBillingData = 'api/services/payments/get_billing_data.php';
export const endpointPaymentsSendBillingReminder = 'api/services/payments/send_billing_reminder.php';
export const endpointPaymentsSendReportPublished = 'api/services/payments/send_report_published.php';
export const endpointPaymentsChangeSession = 'api/services/payments/change_session.php';

// Biblio module (Mi tienda) - accounts/ink API
export const endpointBiblioList = 'api/services/biblio/admin_list_biblios.php';
export const endpointBiblioAvailableAccounts = 'api/services/biblio/admin_available_accounts.php';
export const endpointBiblioGet = 'api/services/biblio/admin_get_biblio.php';
export const endpointBiblioCreate = 'api/services/biblio/admin_create_biblio.php';
export const endpointBiblioUpdate = 'api/services/biblio/admin_update_biblio.php';
export const endpointBiblioDeploy = 'api/services/biblio/admin_deploy_biblio.php';
export const endpointBiblioPause = 'api/services/biblio/admin_pause_biblio.php';
export const endpointBiblioDelete = 'api/services/biblio/admin_delete_biblio.php';
export const endpointBiblioReport = 'api/services/biblio/admin_biblio_report.php';

// Channels management (Gestión de canales) - distribution API
export const endpointChannelsAdminGet = 'admin_get_channels';
export const endpointChannelsAdminSet = 'admin_set_channel';
export const endpointChannelsAdminDelete = 'admin_delete_channel';
export const endpointChannelsAdminGetCategories = 'admin_get_categories';
export const endpointChannelsAdminRevealPassword = 'admin_reveal_channel_password';


export const endpointNewsletterConfigs = 'api/newsletter/configs';
export const endpointNewsletterChannels = 'api/newsletter/channels';
export const endpointNewsletterMainCategories = 'api/newsletter/main-categories';
export const endpointNewsletterUploadCover = 'api/newsletter/upload-cover';
export const endpointNewsletterPreview = 'api/newsletter/novedades/preview';
export const endpointNewsletterSend = 'api/newsletter/novedades/send';
